import axios from "@/api/axios";
import store from "@/store";
import _ from "lodash";
import qs from "qs";

// 토큰 가지고 오기
const getMain = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    noticetop5cnt: "0",
    noticetop5: [
      {
        no: 0,
        type: "",
        title: "",
        date: "",
        noticeno: "",
      },
    ],
    roundsummary: [
      {
        roundtodaycnt: "0",
        roundtotalcnt: "0",
        playertodaycnt: "0",
        playertotalcnt: "0",
      },
    ],
    torunamentsummary: [
      {
        tournamenttodaycnt: "0",
        tournamenttotalcnt: "0",
        roundtodaycnt: "0",
        roundtotalcnt: "0",
        playertodaycnt: "0",
        playertotalcnt: "0",
      },
    ],
  };
  const options = {
    method: "GET",
    url: "/summary",
    params: param,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // data: qs.stringify({})
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);

        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("getToken", err);
    result(false, err);
  }
};

export default {
  getMain,
};
